import Marquee from "react-fast-marquee";

// Signature meta label — pulse dot + text, echoing the hero
export const MetaLabel = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="meta-label">
    <span className="w-2 h-2 rounded-full bg-accent animate-pulse shrink-0" />
    <span className="text-[11px] uppercase tracking-ultra text-ink-soft">{children}</span>
  </div>
);

// Signature kinetic divider — the recurring brand motif
const DEFAULT_ITEMS = [
  "The Art of Estate Management",
  "Il Salotto Digitale",
  "Miami, Florida",
  "Structure · Grace · Precision",
];

export const KineticDivider = ({ items = DEFAULT_ITEMS, dark = false, speed = 42, direction = "left" }) => (
  <div className={`border-y overflow-hidden py-5 lg:py-6 ${dark ? "bg-ink border-ink" : "bg-surface border-line"}`} data-testid="kinetic-divider">
    <Marquee speed={speed} direction={direction} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className={`font-serif italic font-light text-xl lg:text-2xl mx-8 flex items-center gap-8 ${dark ? "text-bg" : "text-ink"}`}>
          {t} <span className="not-italic text-accent">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
